/*
 * W-d4a5a81b: the sentences the Desk's World transport (apps/server
 * worldToolTransport.ts) writes when the World itself did not answer: it ran
 * past the Desk's time limit, the connection failed, its reply broke off, or it
 * answered with a server error. The Desk's `transport` refusal kind also
 * carries local validation failures ("returned a malformed receipt"), so the
 * web Desk tells the person "the World is not answering" only for these.
 */
export const WORLD_NOT_ANSWERING_REASONS = {
  timedOut: "The World door did not answer within its time limit.",
  unreachable: "The World door was unreachable.",
  unreadable: "The World door returned an incomplete or unreadable response.",
  streamSilent: "The World response stream went silent.",
} as const;

/** The transport's sentence for a World HTTP failure (any status but 401). */
export function worldDoorHttpStatusReason(status: number): string {
  return `The World door returned HTTP ${status}.`;
}

const SERVER_ERROR = /The World door returned HTTP 5\d\d\./;
const KNOWN = Object.values(WORLD_NOT_ANSWERING_REASONS);

/** Whether a `transport` refusal's reason says the World itself did not answer. */
export function isWorldNotAnsweringReason(reason: unknown): boolean {
  if (typeof reason !== "string") return false;
  return KNOWN.some((sentence) => reason.includes(sentence)) || SERVER_ERROR.test(reason);
}
